import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutStepWizardStyled } from '../CheckoutStepWizardStyled';
import { rem } from 'polished';

export const CheckoutStepWizardOV = styled(CheckoutStepWizardStyled)``;
